import { useContext, useState } from "react";
import { SuccessAlertContext } from "App";
import type { CompanyConditionParams, CompanyInfo } from "../types";
import companyConditionApi from "../api/companyConditionApi";
import { removeEmptyValues } from "../utils/common";

/**
 * 登録企業リスト取得hooks
 */
export default function useCompanyLookup() {
  const [params, setParams] = useState<CompanyConditionParams>({
    company_name: "",
    company_cd: "",
  });

  const [list, setList] = useState<CompanyInfo[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { showAlert } = useContext(SuccessAlertContext);

  const companyLookup = async () => {
    setIsLoading(true);
    try {
      const companies = await companyConditionApi(removeEmptyValues(params));
      setList(companies);
    } catch (err) {
      console.error(err);
      showAlert("不明なエラー", "error");
    } finally {
      setIsLoading(false);
    }
  };

  return { params, setParams, list, setList, isLoading, companyLookup };
}
